import ApiClient from "../ampm-world";
import {
  HomePageResource,
  HomePageResourceData,
  LegalNoticePageResource,
  ReturnInfoPageResource,
  AboutUsPageResource,
  ShopAddressPageResource,
  ShopAddressPageResourceShops,
  BannerDetailResource,
} from "../generated-api";

export class ApiPage {
  static async getHomePage(lang: string): Promise<HomePageResourceData | undefined> {
    const { data } = await ApiClient.get<HomePageResource>(`/${lang}/page/home`);

    return data;
  }

  static async getLegalNoticePage(lang: string): Promise<LegalNoticePageResource> {
    const data = await ApiClient.get<LegalNoticePageResource>(`/${lang}/page/legal-notice`);

    return data;
  }

  static async getReturnInfoPage(lang: string): Promise<ReturnInfoPageResource> {
    const data = await ApiClient.get<ReturnInfoPageResource>(`/${lang}/page/return-info`);

    return data;
  }

  static async getDetailCategoryPage(lang: string, id: number): Promise<BannerDetailResource> {
    return ApiClient.get<BannerDetailResource>(`/${lang}/page/category/${id}`);
  }

  static async getAboutPage(lang: string): Promise<AboutUsPageResource> {
    const data = await ApiClient.get<AboutUsPageResource>(`/${lang}/page/about-us`);

    return data;
  }

  static async getAddressesPage(lang: string): Promise<ShopAddressPageResourceShops[]> {
    const data = await ApiClient.get<ShopAddressPageResource>(`/${lang}/page/shop-address`);

    return data.shops;
  }
}
